<ul class="list-group">
  <div #scrollableContainer class="scrollable-container">
    <li *ngFor="let skyLayer of skyLayers; index as index" class="list-group-item px-1">
      <div class="d-flex align-items-center" style="width: 450px">
        <div class="d-inline-block d-flex align-items-center col-4">
          <div class="col-1">
            <input id="{{'activate-layer-' + index}}"
                  type="radio"
                  class="form-check-input me-1"
                  [checked]="skyLayer?.active"
                  (click)="activateSkyLayer(index)">
          </div>
          <div ngbDropdown class="d-inline-block col-11">
            <button id="{{'activate-layer-' + index}}"
                    class="btn btn-sm mx-1 dropdown-button"
                    ngbDropdownToggle>
              {{skyLayer?.type}}
            </button>
            <div ngbDropdownMenu>
              <ng-container *ngFor="let skyLayerType of distinctSkyLayerTypes">
                <button ngbDropdownItem
                        *ngIf="skyLayer?.type !== skyLayerType"
                        (click)="selectSkyLayerType(skyLayerType, index)">
                  {{skyLayerType}}
                </button>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="d-inline-block col-4">
          <ng-container *ngIf="getSkyLayersForType(skyLayer?.type).length > 1; else simpleButton">
            <div ngbDropdown>
              <button id="{{'select-layer-' + index}}"
                      class="btn btn-sm mx-1 dropdown-button"
                      ngbDropdownToggle>
                {{skyLayer.label}}
              </button>
              <div ngbDropdownMenu>
                <ng-container *ngFor="let skyLayersForType of getSkyLayersForType(skyLayer?.type)">
                  <button ngbDropdownItem
                          *ngIf="skyLayersForType?.label !== skyLayer?.label"
                          (click)="selectSkyLayerForType(skyLayersForType, index)">
                    {{skyLayersForType.label}}
                  </button>
                </ng-container>
              </div>
            </div>
          </ng-container>
          <!-- Simple button when there's only one item -->
          <ng-template #simpleButton>
            <button class="btn btn-sm mx-1 dropdown-button">
              {{skyLayer.label}}
            </button>
          </ng-template>
        </div>
        <div ngbDropdown class="d-inline-block d-flex align-items-center col-4">
          <div class="col-9 pe-1">
            <button id="{{'select-color-' + index}}"
                    class="btn btn-sm mx-1 dropdown-button"
                    ngbDropdownToggle>
              {{skyLayer.color.label}}
            </button>
            <div ngbDropdownMenu>
              <ng-container *ngFor="let skyLAyersColor of skyLayersColors">
                <button ngbDropdownItem
                        *ngIf="skyLAyersColor?.label !== skyLayer?.color?.label"
                        (click)="selectSkyLayerColor(skyLAyersColor, index)">
                  {{skyLAyersColor.label}}
                </button>
              </ng-container>
            </div>
          </div>
          <div class="col-3">
            <button id="{{'remove-layer-' + index}}"
                    type="button"
                    class="btn btn-sm dropdown-button"
                    placement="top"
                    ngbTooltip="Remove sky"
                    triggers="manual" 
                    #tooltip="ngbTooltip"
                    [container]="'body'"
                    (mouseenter)="showTooltip(tooltip)"
                    (mouseleave)="hideTooltip(tooltip)"
                    (click)="removeSkyLayer(index)"
                    [disabled]="this.skyLayers?.length < 3">
                <i class="fa-light fa-trash-can"></i>
            </button>
          </div>
        </div>
      </div>
    </li>
  </div>
  <li class="list-group-item pt-0 pb-0">
    <div class="d-flex justify-content-end">
      <button id="reset-layers"
              type="button"
              class="btn btn-small me-1"
              placement="top"
              ngbTooltip="Reset skies"
              (click)="resetImages()">
        <i class="fa-light fa-arrows-rotate"></i>
      </button>
      <button id="add-layer"
              type="button"
              class="btn btn-small"
              placement="top"
              ngbTooltip="Add sky"
              (click)="addSky()">
        <i class="fa-light fa-circle-plus"></i>
      </button>
    </div>
  </li>
</ul>